import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { addOfferToBooking } from "../../../app/api/postBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { prepareBookingSummaryAction } from "../../LogicActions/Checkout/Summary/PrepareBookingSummaryAction";
import { getBooking } from "../../../app/api/getBooking";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IAddReturnJourneyToBookingActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/AddReturnJourneyToBookingActionParams";
import { filterBookingByOfferId } from "../../../Lib/Utils/validationUtil";
dayjs.extend(timezone);
dayjs.extend(utc);

export class AddReturnJourneyToBookingAction extends BaseAction<IDefaultActionResult, IAddReturnJourneyToBookingActionParams> {

    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { offerId, bookingId, passengers } = this.params!
            if (offerId && bookingId && passengers) {
                const offerIds = Array.isArray(offerId) ? offerId : [offerId];
                const passengerRefs = passengers.map(passenger => passenger.externalRef);
                
                const payload = {
                    offers: offerIds.map((id: string) => ({
                        offerId: id,
                        passengerRefs: passengerRefs
                    }))
                }
                const response: any = await addOfferToBooking(bookingId, payload);
                if (response.status === 'ok' && response.answer) {

                    const bookingResponse = await getBooking(bookingId)
                    if (bookingResponse.status === 'ok' && bookingResponse.answer) {
                        const booking = bookingResponse.answer;
                        //console.log("booking", booking);
                        // Filter the booking to only include data related to the new offers
                        const filteredBooking = filterBookingByOfferId(booking, offerIds);
                        //console.log("filteredBooking", filteredBooking);
                        // Remember the narrowing so a later full re-read cannot
                        // undo it. Every End-to-end add (Nol, shuttle) ends by
                        // re-reading the whole booking; without this the paid
                        // outbound came back into this checkout's summary AND
                        // its total. Cleared once payment settles.
                        updateRecoilState('bookingScopeAtom', {
                            bookingId: bookingId,
                            offerIds: offerIds,
                        });
                        updateRecoilState('bookingResponseAtom', filteredBooking);
                        prepareBookingSummaryAction.setParams(filteredBooking.booking);
                        await prepareBookingSummaryAction.execute();
                        actionResult.status = "success";
                    }
                }
            }
        }
        catch (error) {
            console.log("Error during booking again:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const addReturnJourneyToBookingAction = new AddReturnJourneyToBookingAction(); 